import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { ClientTypeItem, SslProtocolItem, RequestCategoryItem } from '../../types';
import { formatNumber, CLIENT_TYPE_LABELS } from '../../constants/nginx-sites';

interface SecurityOverviewProps {
  clientTypes: ClientTypeItem[] | null;
  sslProtocols: SslProtocolItem[] | null;
  requestCategories: RequestCategoryItem[] | null;
}

export function SecurityOverview({ clientTypes, sslProtocols, requestCategories }: SecurityOverviewProps) {
  const scannerCount = clientTypes?.find((c) => c.clientType === 'scanner')?.count || 0;
  const botCount = clientTypes?.find((c) => c.clientType === 'bot')?.count || 0;
  const probeCount = requestCategories?.find((c) => c.category === 'probe')?.count || 0;

  return (
    <div className="space-y-4">
      {/* KPI row */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">Scanners Bloqueados</p>
            <p className="text-2xl font-bold text-red-600 dark:text-red-400">{formatNumber(scannerCount)}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">Requisições de Bots</p>
            <p className="text-2xl font-bold text-amber-500 dark:text-amber-400">{formatNumber(botCount)}</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-4 pb-4">
            <p className="text-xs font-medium text-muted-foreground mb-1">Sondas (Probes)</p>
            <p className="text-2xl font-bold text-orange-500 dark:text-orange-400">{formatNumber(probeCount)}</p>
          </CardContent>
        </Card>
      </div>

      {/* SSL Protocols */}
      {sslProtocols && sslProtocols.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Protocolos SSL</CardTitle>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Protocolo</TableHead>
                  <TableHead className="text-right">Requisições</TableHead>
                  <TableHead className="text-right">%</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {sslProtocols.map((item) => (
                  <TableRow key={item.protocol}>
                    <TableCell className="font-mono text-sm">{item.protocol}</TableCell>
                    <TableCell className="text-right">{formatNumber(item.count)}</TableCell>
                    <TableCell className="text-right">{item.percentage.toFixed(1)}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}

      {/* Client type breakdown (non-customer) */}
      {clientTypes && clientTypes.filter((c) => c.clientType !== 'customer').length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle>Tráfego Não-Humano</CardTitle>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Tipo</TableHead>
                  <TableHead className="text-right">Requisições</TableHead>
                  <TableHead className="text-right">Visitantes</TableHead>
                  <TableHead className="text-right">%</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {clientTypes
                  .filter((c) => c.clientType !== 'customer')
                  .map((item) => (
                    <TableRow key={item.clientType}>
                      <TableCell>{CLIENT_TYPE_LABELS[item.clientType] || item.clientType}</TableCell>
                      <TableCell className="text-right">{formatNumber(item.count)}</TableCell>
                      <TableCell className="text-right">{formatNumber(item.visitors)}</TableCell>
                      <TableCell className="text-right">{item.percentage.toFixed(1)}%</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
